export default "__VITE_ASSET__zDONRV2j__"